import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { useAuth } from "../../../hooks/useAuth";
import { ResetPasswordForm } from "../../organisms/form/ResetPasswordForm";
import { useResetPassword } from "./hook";

export const ResetPassword: React.FC = () => {
  const { handlePasswordError } = useAuth();
  const { key, handleResetPassword } = useResetPassword();

  return (
    <Container>
      <TitleWrapper>パスワード再設定</TitleWrapper>
      <Message>
        変更する新しいパスワードをご入力し、「変更」ボタンをクリックすると、パスワードが変更されまさす。
      </Message>
      <Message>※印は必須項目です。</Message>

      <ResetPasswordForm
        handlePasswordError={handlePasswordError}
        handleSubmit={(code, password, passwordConfirmation) =>
          handleResetPassword(key ?? "", code, password, passwordConfirmation)
        }
      />
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px 25px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  padding: 43px 0 38px;
  display: flex;
  line-height: 1;
  font-weight: 500;
  justify-content: center;
  line-height: 1em;
  font-family: "Hiragino Sans";
`;

const Message = styled.div`
  text-align: left;
  margin-bottom: 26px;
  font-size: 14px;
  font-family: "Hiragino Sans";
  font-weight: 200;
`;
